import { aiAgentAsCsApis } from './ascs/apis';
import { aiAgentCompanyApis } from './company/apis';
import { aiAgentFileApis } from './file/apis';
import { aiAgentManualApis } from './manual/apis';
import { aiAgentModelApis } from './model/apis';
import { aiAgentTemplateApis } from './template/apis';

export const aiAgentApis = {
  template: aiAgentTemplateApis,
  model: aiAgentModelApis,
  manual: aiAgentManualApis,
  company: aiAgentCompanyApis,
  file: aiAgentFileApis,
  ascs: aiAgentAsCsApis,
};
